import { ChangeEvent, ReactNode } from "react";
import { NavLink } from "react-router-dom";
import CourseService from "../../../services/education/CourseService";
import AuthenticatedComponent from "../../base/AuthenticatedComponent/AuthenticatedComponent";
import RegisterReportState, { RegisterReportProps, TitleValueView } from "./RegisterReport.models";
import './RegisterReport.scss';
import RegisterReportIcon from '../../../assest/images/card-image/Item-Avatar.png';
import NotifyContext from "../../../contexts/NotifyContext";

export default class RegisterReport extends AuthenticatedComponent<RegisterReportProps, RegisterReportState>{
    static contextType = NotifyContext
    courseService: CourseService;

    constructor(props: any) {
        super(props);
        this.courseService = new CourseService();
        this.state = { courses: [], searchText: '', isSelectedAll: false };
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let self = this;
        self.courseService.getCourseList().then(function (response) {
            let result: TitleValueView<number>[] = response.map(titleValue => (
                {
                    value: titleValue.value ?? 0, title: titleValue.title, descrption: '', isSelected: false
                }
            ));
            self.setState({ courses: result });
        });

    }

    getSubmitReportForExamReultPage = () => {
        let state = this.state;
        let courses = state.courses;

        if (courses.filter(course => course.isSelected).length === 0) {
            this.context.showNotify({ badge: "danger", title: "رخداد خطا", description: "لطفا ابتدا درس مورد نظر خود را انتخاب نمایید" });
            return;
        }

        this.props.afterSelect(courses.filter(course => course.isSelected));
    }

    handleCheck = (course: TitleValueView<number>, event: string) => {
        var courses = this.state.courses;
        let index = courses.indexOf(course);
        course.isSelected = !course.isSelected;
        courses[index] = course;
        this.setState({ courses: courses });
        this.forceUpdate();
    };

    changeListSelection = (value: boolean) => {
        var courses = this.state.courses;
        courses.map(course => course.isSelected = value);
        this.setState({ courses: courses });
        this.forceUpdate();
    }

    changeSelectedAll = () => {
        this.changeListSelection(!this.state.isSelectedAll);
        this.setState({ isSelectedAll: !this.state.isSelectedAll });
    }

    render(): ReactNode {
        let { courses, searchText, isSelectedAll } = this.state;
        return (<>
            <div className="content-body register-report-area">
                <div className="main-content">

                    {this.headerView(searchText)}

                    <div className="course-Detail px-4">
                        <div className="title">
                            <label>ثبت گزارش کار</label>
                        </div>
                        <div className="subtitle">
                            <label>درس مورد نظر برای ثبت گزارش کار را انتخاب کنید</label>
                        </div>

                        {this.courseListView(courses, searchText)}

                        {this.footerView(courses, isSelectedAll)}
                    </div>
                </div >
            </div >
        </>);
    }


    headerView(searchText: string) {
        return (<div className="co-header">
            <div className="col-12">
                <div className="tk-inline">
                    <div className="magnify-icon col-10 notspace">
                        <span className="mdi mdi-magnify"></span>
                        <input className="tk-form-controll" style={{ outline: "none" }} value={searchText} onChange={e => this.setState({ searchText: e.target.value })} placeholder="جستجو" />
                    </div>
                    <NavLink to={"/Dashboard"} className="close-icon col-2 notspace">
                        <label className="mdi mdi-close" ></label>
                    </NavLink>
                </div>
            </div>
        </div>);
    }
    footerView(courses: TitleValueView<number>[], isSelectedAll: boolean) {
        let content;
        if (isSelectedAll)
            content = (<label htmlFor="SelectAll" className="mdi mdi-checkbox-multiple-blank-outline" style={{ marginBottom: "0" }} onClick={this.changeSelectedAll}></label>);
        else content = (<label htmlFor="SelectAll" className="mdi mdi-checkbox-multiple-marked-outline" style={{ marginBottom: "0" }} onClick={this.changeSelectedAll}></label>);

        return (<div className="Couse-action">
            <div className="col-12 notspace">
                <div className="tk-inline">
                    <div className="col-10 notspace">
                        <button className="btn btn-primary loc-bottom" style={{ width: "73%" }} onClick={this.getSubmitReportForExamReultPage}>
                            ثبت گزارش کار برای این
                            {courses.filter(course => course.isSelected).length} درس
                        </button>
                    </div>
                    <div className="col-2">
                        <label className="btn btn-primary loc-bottom" style={{ marginBottom: "0" }}>
                            <input id="SelectAll" type="checkbox" hidden checked={isSelectedAll} onChange={e => e.target.value} />
                            {content}
                        </label>
                    </div>
                </div>
            </div>
        </div>);
    }
    courseListView(courses: TitleValueView<number>[], searchText: string) {
        return (courses.length > 0 ? (<>
            <div className="dropdown-list" style={{ height: "70vh" }}>

                {courses.sort(course => course.value).filter(course => course.title.includes(searchText)).map((course) => {
                    return this.courseCardView(course);
                })}
            </div>
        </>) : '');
    }
    courseCardView(course: TitleValueView<number>) {
        return (<div key={course.value} className="tk-card" onClick={e => this.handleCheck(course, "true")}>
            <div className="col-12 notspace">
                <div className="tk-inline" >
                    <div className="col-2 notspace" >
                        <img src={RegisterReportIcon} width="56" height="72" alt="register report icon" />
                    </div>
                    <div className="col-8 notspace" >
                        <div className="pd-detail">
                            <div className="course-title">
                                <label>{course.title} </label>
                            </div>
                            <div className="course-subtitle">
                                <label>ثبت گزارش کار برای این درس</label>
                            </div>
                        </div>
                    </div>
                    <div className="col-2 notspace">
                        <div className="pd-Checkbox">
                            <label className="container">
                                <input checked={course.isSelected} type={"checkbox"} onChange={e => this.handleCheck(course, e.target.value)} />
                                <span className="checkmark"></span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }
}